import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import InvoiceTypeModal from "./invoice-type-modal/InvoiceTypeModal";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { BillingInvoice, TopUpInvoice } from "./topup-invoice/TopUpInvoice";
import {
  initialFilterInvoiceList,
  PAYMENT_STATUS,
} from "./DetailTopUpInvUIHelpers";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import InvoiceTable from "./invoice-table/InvoiceTable";
import { createTopUpPayment, getInvoiceDetail } from "../../_redux/topUpAction";

export const DetailInvoiceCard = ({ id, history }) => {
  // Getting curret state of billing list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({
      currentState: state.topUp,
    }),
    shallowEqual
  );

  const [topupPayment, setTopupPayment] = useState({});

  const { listLoading, actionsLoading, detailInvoice = {} } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset API
    dispatch(getInvoiceDetail(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch]);

  useEffect(() => {
    if (detailInvoice.topup_payment)
      setTopupPayment(
        detailInvoice.topup_payment.find((item) => {
          if (item.status === "PAID") {
            return item;
          } else if (item.status === "WAITING") {
            return item;
          } else if (item.status === "FAILED") {
            return item;
          }
        })
      );
  }, [currentState]);

  const [showModal, setShowModal] = useState({
    invoiceType: false,
  });

  const createPayment = (values) => {
    const { code, type, uuid, name } = values;
    const data = {
      topup_invoice_uuid: detailInvoice.uuid,
      payment_method_uuid: uuid,
      payment_method_type: type,
      payment_method_code: code,
      payment_method_name: name,
      payment_amount: detailInvoice.invoice_grand_total,
    };
    dispatch(createTopUpPayment(data)).then(() => {
      dispatch(getInvoiceDetail(id));
      setShowModal((prevState) => ({
        ...prevState,
        invoiceType: false,
      }));
    });
  };

  return (
    <>
      <LoadingAnimation open={listLoading || actionsLoading} />
      <InvoiceTypeModal
        show={showModal.invoiceType}
        onHide={() =>
          setShowModal((prevState) => ({
            ...prevState,
            invoiceType: false,
          }))
        }
        createPayment={createPayment}
      />
      <Card>
        <CardHeader title="Invoice">
          <CardHeaderToolbar>
            <button
              className="btn btn-secondary mr-4"
              onClick={() => history.push("/billing/top-up")}
            >
              <i className="fa fa-arrow-left"></i>
              Back
            </button>
            {detailInvoice.status === "WAITING" && (
              <button
                className="btn btn-primary"
                onClick={() =>
                  setShowModal((prevState) => ({
                    ...prevState,
                    invoiceType: true,
                  }))
                }
              >
                Pilih Pembayaran
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <TopUpInvoice topupPayment={topupPayment} />
        </CardBody>
      </Card>
      <Card>
        <CardHeader title="Tagihan Berjalan" />
        <CardBody>
          <InvoiceTable
            invoiceItem={detailInvoice.topup_invoice_item}
            topUpInvoice={detailInvoice}
            listLoading={listLoading}
          />
        </CardBody>
      </Card>
    </>
  );
};
